var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-delivery',
                        view: publicPath + 'sprite.svg#view-icon-delivery',
                        viewBox: '0 0 32 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };